// Blink dash ability — demo new ability (triggered from abilities-runtime on SP+move).

import { registerAbility } from '../abilities';

registerAbility({
  id: 'dash-blink',
  name: 'Blink Dash',
  gemCost: 50,
  cooldownMs: 3000,
  isUnlocked: (world) => world.g.explored >= 100,
});
